<template>
  <div>
    <div class="package-card card" @click="goToNext(hnlSummary.cpidstring)">
      <div class="facade-image">
        <figure class="image is-3by2" v-if="hnlSummary.imagepath">
          <img :src="hnlSummary.imagepath" alt="" />
        </figure>
        <div class="marker-overlay right">
          <a v-if="!isFavorite" v-on:click="addToFavorites(hnlSummary)">
            <i class="far fa-heart"></i>
          </a>

          <a
            v-if="isFavorite"
            v-on:click="removeFromFavorites(hnlSummary.cpidstring)"
          >
            <i class="fas fa-heart"></i>
          </a>
        </div>
      </div>
      <div class="card-info">
        <div class="columns is-mobile is-gapless">
          <div class="column design">
            <p class="design">{{ hnlSummary.designproductname }}</p>
            <p class="d">{{ hnlSummary.buildername }}</p>
          </div>
          <div class="column is-narrow">
            <div class="amenities">
              <div class="amenity">
                <img :src="require('@/assets/icons/bed.svg')" alt="" />
                <span>{{ hnlSummary.noofbedrooms }}</span>
              </div>
              <div class="amenity">
                <img :src="require('@/assets/icons/bath.svg')" alt="" />
                <span>{{ hnlSummary.noofbathrooms }}</span>
              </div>
              <div class="amenity">
                <img :src="require('@/assets/icons/car.svg')" alt="" />
                <span>{{ hnlSummary.noofcarparks }}</span>
              </div>
            </div>
            <div class="price">
              <p
                class="p"
                v-if="hnlSummary.productprice"
              >
                {{
                  formatCurrency(hnlSummary.productprice)
                }}
              </p>
            </div>
          </div>
        </div>
        <div class="columns is-mobile is-gapless">
          <div class="column dimensions">
            <div class="dimension">
              <p class="t">Home Area</p>
              <p class="d">
                {{ hnlSummary.homesize.toLocaleString() }}<small> sqft</small>
              </p>
            </div>
          </div>
          <div class="column is-narrow">
            <a class="button app-accent">
              View Home
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    hnlSummary: {
      type: Object
    },
    isFavorite: {
      type: Boolean,
      default: false
    }
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    locatePackage: function(lotcpid) {
      this.$emit("locatePackage", lotcpid);
    },

    addToFavorites: function(hnlsummary) {
      this.$store.dispatch("setFavoritePackageDetail", hnlsummary);
      this.$store.dispatch("setFavoriteHnl", hnlsummary.cpidstring);
    },

    removeFromFavorites: function(id) {
      this.$store.dispatch("removeFavoritesHnl", id);
    },

    formatCurrency: function(value) {
      if (value) {
        return value.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        });
      } else {
        return "$0";
      }
    },

    viewDetail: function(hnl) {},

    goToNext: function(id) {
      let path = "/community/package/" + id;
      const origin = this.$route.params.origin;
      if (origin) {
        path = path + "/" + origin;
      }
      return this.$router.push({
        path: path
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/journey/spec/PackageCard.vue